/**
 * Copyright 2020-present, TIENDUC.
 * All rights reserved.
 * @author ductt24@ghtk.vn on 11/08/2020.
 * @module TRUCK ACTIONS
 */

import {
  BROWSE_PRINTER,
  BROWSE_PRINTER_STATUS,
  BROWSE_PRINTER_REPAIR_BY_WEEK,
  BROWSE_PRINTER_RECENT_DATE,
  BROWSE_PRINTER_DAY_OF_USE,
  CHANGE_PRINTER_PARAM,
  SET_TOTAL,
  BROWSE_PRINTER_TAG,
  EXPORT_PRINTER_REPORT,
} from "./constants";
import { createAction, nanoid } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { createRoutine } from "redux-saga-routines";

export const PRINTER_DATA_NAME = {
  PRINTER: "printer",
  PRINTER_TAG: "printerTag",
  PRINTER_REPORT: "printerReport",
  PRINTER_STATUS: "printerStatus",
  PRINTER_REPAIR_BY_WEEK: "printerRepairByWeek",
  PRINTER_RECENT_DATE: "printerRecentDate",
  PRINTER_DAY_OF_USE: "printerDayOfUse",
};
const prepare = (payload) => {
  return {
    ...payload,
    actionId: nanoid(),
    createdAt: dayjs(),
  };
};

/**
 * Action lấy dữ liệu trạng thái máy in
 */
export const browsePrinterStatus = createRoutine(
  BROWSE_PRINTER_STATUS,
  (payload) =>
    prepare({
      ...payload,
      isCommon: true,
      dataPath: [PRINTER_DATA_NAME.PRINTER_STATUS],
      uiPath: [PRINTER_DATA_NAME.PRINTER_STATUS],
    }),
  () => ({
    isNormalize: false,
  })
);
/**
 * Action lấy dữ liệu báo cáo máy in sửa chữa trong tuần
 */
export const browsePrinterRepairByWeek = createRoutine(
  BROWSE_PRINTER_REPAIR_BY_WEEK,
  (payload) =>
    prepare({
      ...payload,
      isCommon: true,
      dataPath: [PRINTER_DATA_NAME.PRINTER_REPAIR_BY_WEEK],
      uiPath: [PRINTER_DATA_NAME.PRINTER_REPAIR_BY_WEEK],
    }),
  () => ({
    isNormalize: false,
  })
);
/**
 * Action lấy dữ liệu báo cáo thời gian hoạt động gần nhất
 */
export const browsePrinterRecentDate = createRoutine(
  BROWSE_PRINTER_RECENT_DATE,
  (payload) =>
    prepare({
      ...payload,
      isCommon: true,
      dataPath: [PRINTER_DATA_NAME.PRINTER_RECENT_DATE],
      uiPath: [PRINTER_DATA_NAME.PRINTER_RECENT_DATE],
    }),
  () => ({
    isNormalize: false,
  })
);
/**
 * Action lấy dữ liệu báo cáo máy in số ngày sử dụng sử dụng
 */
export const browsePrinterDayOfUse = createRoutine(
  BROWSE_PRINTER_DAY_OF_USE,
  (payload) =>
    prepare({
      ...payload,
      isCommon: true,
      dataPath: [PRINTER_DATA_NAME.PRINTER_DAY_OF_USE],
      uiPath: [PRINTER_DATA_NAME.PRINTER_DAY_OF_USE],
    }),
  () => ({
    isNormalize: false,
  })
);
/**
 * Action lấy danh sách máy in
 */
export const browsePrinter = createRoutine(
  BROWSE_PRINTER,
  (payload) =>
    prepare({
      ...payload,
      isCommon: true,
      dataPath: [PRINTER_DATA_NAME.PRINTER],
      uiPath: [PRINTER_DATA_NAME.PRINTER],
    }),
  () => ({
    isNormalize: false,
  })
);
/**
 * Action lấy danh sách Printer tag
 */
export const browsePrinterTag = createRoutine(
  BROWSE_PRINTER_TAG,
  (payload) =>
    prepare({
      ...payload,
      isCommon: true,
      dataPath: [PRINTER_DATA_NAME.PRINTER_TAG],
      uiPath: [PRINTER_DATA_NAME.PRINTER_TAG],
    }),
  () => ({
    isNormalize: false,
  })
);
/**
 * Action lấy danh sách Printer tag
 */
export const exportPrinterReport = createRoutine(
  EXPORT_PRINTER_REPORT,
  (payload) =>
    prepare({
      ...payload,
      isCommon: true,
      dataPath: [PRINTER_DATA_NAME.PRINTER_REPORT],
      uiPath: [PRINTER_DATA_NAME.PRINTER_REPORT],
    }),
  () => ({
    isNormalize: false,
  })
);
/**
 * Action change video param
 */
export const changePrinterParam = createAction(CHANGE_PRINTER_PARAM);
export const setTotal = createAction(SET_TOTAL);
